exports = module.exports = require("../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.vux-group-tip, .vux-group-tip p {\n  font-size:14px;\n  color:#888;\n  text-align:center;\n  padding-top:0.3em;\n  padding-left:10px;\n  padding-right:5px;\n}\n.vux-group-tip .weui-icon {\n  padding-right: 3px;\n}\n", "", {"version":3,"sources":["E:/h5/z-project-other/xinhuayun-h5/node_modules/vux/src/components/tip/index.vue"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB","file":"index.vue","sourcesContent":["\n.vux-group-tip, .vux-group-tip p {\n  font-size:14px;\n  color:#888;\n  text-align:center;\n  padding-top:0.3em;\n  padding-left:10px;\n  padding-right:5px;\n}\n.vux-group-tip .weui-icon {\n  padding-right: 3px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09e4095d","scoped":false,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vux/src/components/tip/index.vue
// module id = s9U2
// module chunks = 0